import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { Link, useLocation } from 'react-router-dom';
import classNames from 'classnames';
import PageWrapper from '../../layout/PageWrapper/PageWrapper';
import Page from '../../layout/Page/Page';
import Card, { CardBody } from '../../components/bootstrap/Card';
import Button from '../../components/bootstrap/Button';
import Logo from '../../components/Logo';
import useDarkMode from '../../hooks/useDarkMode';
import SignIn from './SignIn';
import Registration from './Registration';

const Login = () => {
	const { darkModeStatus } = useDarkMode();

	const [isNewUser, setIsNewUser] = useState(false);

	const { state } = useLocation();

	useEffect(() => {
		if (state) {
			if (state.message) {
				swal('Yaay!', state.message, 'success');
			} else if (state.error) {
				swal('Oops!', state.error, 'error');
			} else if (state.warning) {
				swal('Notice!', state.warning, 'warning');
			}
		}
		window.history.replaceState({}, document.title);
	}, [state]);

	return (
		<PageWrapper
			title={isNewUser ? 'Sign Up' : 'Login'}
			className={classNames({ 'bg-primary': !isNewUser, 'bg-info': !!isNewUser })}>
			<Page className='p-0'>
				<div className='row h-100 align-items-center justify-content-center'>
					<div className='col-xl-6 col-lg-6 col-md-8 shadow-3d-container'>
						<Card className='shadow-3d-dark' data-tour='login-page'>
							<CardBody>
								<div className='text-center my-5'>
									<Link
										to='/'
										className={classNames(
											'text-decoration-none  fw-bold display-2',
											{
												'text-dark': !darkModeStatus,
												'text-light': darkModeStatus,
											},
										)}>
										<Logo width={200} />
									</Link>
								</div>
								<div
									className={classNames('rounded-3', {
										'bg-l10-dark': !darkModeStatus,
										'bg-lo10-dark': darkModeStatus,
									})}>
									<div className='row row-cols-2 g-3 pb-3 px-3 mt-0'>
										<div className='col'>
											<Button
												type='button'
												color={darkModeStatus ? 'light' : 'dark'}
												isLight={!!isNewUser}
												className='rounded-1 w-100'
												size='lg'
												onClick={() => {
													setIsNewUser(!isNewUser);
												}}>
												Login
											</Button>
										</div>
										<div className='col'>
											<Button
												type='button'
												color={darkModeStatus ? 'light' : 'dark'}
												isLight={!isNewUser}
												className='rounded-1 w-100'
												size='lg'
												onClick={() => {
													setIsNewUser(!isNewUser);
												}}>
												Sign Up
											</Button>
										</div>
									</div>
								</div>
								{isNewUser ? <Registration /> : <SignIn />}
							</CardBody>
						</Card>
						<div className='text-center'>
							<a href='/' className='text-decoration-none me-3 link-light'>
								Privacy policy
							</a>
							<a href='/' className='link-light text-decoration-none link-light'>
								Terms of use
							</a>
						</div>
					</div>
				</div>
			</Page>
		</PageWrapper>
	);
};

export default Login;
